import { render, staticRenderFns } from "./I8nQuillEditor.vue?vue&type=template&id=26e04c92&"
import script from "./I8nQuillEditor.vue?vue&type=script&lang=js&"
export * from "./I8nQuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./I8nQuillEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports